class SliderNH extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var thumbnailSlider = new Swiper(".thumbnail-slider", {
      spaceBetween: 10,
      slidesPerView: 4,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    var mainSlider = new Swiper(".main-slider", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbnailSlider,
      },
    });
  }

  disconnectedCallback() {}
}

customElements.define("slider-nh", SliderNH);
